module.exports = __webpack_public_path__ + "static/Srinivasa-9-624b1e6d9e648e59828f3c8be67d7d31.jpeg";